<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Dropdown
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content">
  <h2>Use Case 1: Simple</h2>
  <maced-dropdown dropdownId="dropdownId1" [hasError]="true" name="dropdownId1" ariaLabel="Dropdown list navigate with tab" ariaDiscribedBy="dropdowntext1" label="label" dropdownText="Dropdown"
    cheveronClass="icon-chevron-down" [options]="options1" [selectedOption]="selectedOptions1" outerLabel="Label"
    dropdownLabelId="dropdownLabelId0" inputLableId="inputLableId">
    <ng-container ngProjectAs="[message]">
      <div class="c-dropdown__helper-text" id="dropdowntext1">
        This is helper text
      </div>
    </ng-container>
  </maced-dropdown>

  <h2>Use Case 2: With Checkbox</h2>
  <ng-container *ngIf="isBrowser; else notBrowserTemplate">
    <maced-dropdown dropdownId="dropdownId2" name="dropdownId2" ariaLabel="Dropdown list navigate with tab" [label]="label" dropdownText="Dropdown"
      dropdownLabelId="dropdownLabelId1" cheveronClass="icon-chevron-down" [hasCheckboxesDropdown]="true"
      [options]="options2" outerLabel="Label" [required]="true" [selectedOption]="selectedOptions2"
      (change)="onChange()">
      <ng-container ngProjectAs="[message]">
        <div class="c-dropdown__helper-text">
          This is helper text
        </div>
      </ng-container>
    </maced-dropdown>
  </ng-container>
  <ng-template #notBrowserTemplate>
    <form action="/dropdown" method="get">
      <maced-dropdown dropdownId="dropdownId2" name="dropdownId2" ariaLabel="Dropdown list navigate with tab" [label]="label" dropdownText="Dropdown"
        dropdownLabelId="dropdownLabelId2" cheveronClass="icon-chevron-down" [hasCheckboxesDropdown]="true"
        [options]="options2" [selectedOption]="selectedOptions2" outerLabel="Label">
        <ng-container ngProjectAs="[message]">
          <div class="c-dropdown__helper-text">
            This is helper text
          </div>
        </ng-container>
      </maced-dropdown>
      <maced-button buttonId="submit" label="Submit" buttonType="submit"></maced-button>
    </form>
  </ng-template>
  <div class="result-class">
    Result:- {{ options2 | json }}
  </div>

  <h2>Use Case 3: With Leading Icon</h2>
  <maced-dropdown dropdownId="dropdownId3" name="dropdownId3" ariaLabel="Dropdown list navigate with tab" label="Select" dropdownText="Dropdown"
    dropdownLabelId="dropdownLabelId3" cheveronClass="icon-chevron-down" iconClass="icon-user-circle" [hasIcon]="true"
    [options]="options3" [selectedOption]="selectedOptions3" outerLabel="Label" [required]="true">
    <ng-container ngProjectAs="[message]">
      <div class="c-dropdown__helper-text">
        This is helper text
      </div>
    </ng-container>
  </maced-dropdown>

  <h2>Use Case 4: With Icon As Label</h2>
  <maced-dropdown dropdownId="dropdownId4" name="dropdownId4" ariaLabel="Dropdown list navigate with tab" cheveronClass="icon-dots-vertical"
    [options]="options4" dropdownText="Dropdown">
  </maced-dropdown>

  <ng-container *ngIf="isBrowser">
    <h2>Use Case 5: Dropdown with Event and form attribute</h2>
    <form action="/dropdown" method="get" id="form1">
      <maced-dropdown dropdownId="dropdownId5" name="dropdownId5" ariaLabel="Dropdown list navigate with tab"
        label="Select" dropdownText="Dropdown" dropdownLabelId="dropdownLabelId4" cheveronClass="icon-chevron-down"
        [options]="options5" formId="form1" [selectedOption]="selectedOptions5"
        (menuEvent)="menuEvent($event, 'eventValue')" outerLabel="Label" [required]="true"
        [hasSubmitFormData]="hasSubmitFormData">
        <ng-container ngProjectAs="[message]">
          <div class="c-dropdown__helper-text">
            This is helper text
          </div>
        </ng-container>
      </maced-dropdown>
    </form>
    <h2>Use Case 6: Dropdown without form attribute and button type button</h2>
    <div class="content__row">
      <div class="c-input-check-inline" *ngIf="isBrowser">
        <input id="hasSubmitFormData" class="c-input-check-inline__input" type="checkbox" name="hasSubmitFormData"
          [(ngModel)]="hasSubmitFormData">
        <label for="hasSubmitFormData" class="c-input-check-inline__label">Has Submit</label>
      </div>
    </div>
    <maced-dropdown dropdownId="dropdownId8" name="dropdownId8" ariaLabel="Dropdown list navigate with tab" label="Select"
      dropdownLabelId="dropdownLabelId6" cheveronClass="icon-chevron-down" [options]="options8" dropdownText="Dropdown"
      [selectedOption]="selectedOptions8" (menuEvent)="menuEvent($event, 'eventValue8')" outerLabel="Label"
      [required]="true" [hasSubmitFormData]="hasSubmitFormData">
      <ng-container ngProjectAs="[message]">
        <div class="c-dropdown__helper-text">
          This is helper text
        </div>
      </ng-container>
    </maced-dropdown>
  </ng-container>

  <h2>Use Case 7: Dropdown Error</h2>
  <maced-dropdown dropdownId="dropdownId6" name="dropdownId6" ariaLabel="Dropdown list navigate with tab" ariaDiscribedBy="dropdowntext7" label="Select" outerLabel="Label"
    dropdownLabelId="dropdownLabelId7" cheveronClass="icon-chevron-down" [options]="options6" dropdownText="Dropdown"
    [selectedOption]="selectedOptions6" (menuEvent)="menuEvent($event, 'errorValue')" [hasError]="false">
  </maced-dropdown>
  <span class="c-dropdown__error-text" id="dropdowntext7" *ngIf="!selectedOptions6">This is required field.</span>

  <h2>Use Case 8: Dropdown Disabled</h2>
  <maced-dropdown dropdownId="dropdownId7" name="dropdownId7" ariaLabel="Dropdown list navigate with tab" label="Select" dropdownText="Dropdown"
    cheveronClass="icon-chevron-down" [options]="options7" [selectedOption]="selectedOptions7" outerLabel="Label"
    [disabled]="true" [required]="true">
    <ng-container ngProjectAs="[message]">
      <div class="c-dropdown__helper-text">
        This is helper text
      </div>
    </ng-container>
  </maced-dropdown>

  <h2>Use Case 9: Dropdown with multi-sections and clear button </h2>
  <maced-dropdown dropdownId="dropdownId11" name="dropdownId11" ariaLabel="Dropdown list navigate with tab" label="label" dropdownText="Dropdown"
    cheveronClass="icon-chevron-down" [options]="options10" [selectedOption]="selectedOptions10" outerLabel="Label"
    dropdownLabelId="dropdownLabelId11" [hasMultiSection]="true" [hasSingleButton]="true" [buttonData]="buttonData">
    <ng-container ngProjectAs="[message]">
      <div class="c-dropdown__helper-text">
        This is helper text: {{ selectedOptions10?.label ? selectedOptions10?.label : label1 }}
      </div>
    </ng-container>
  </maced-dropdown>

  <h2>Use Case 10: Dropdown with clear button </h2>
  <maced-dropdown dropdownId="dropdownId12" name="dropdownId12" ariaLabel="Dropdown list navigate with tab" label="label" dropdownText="Dropdown"
    cheveronClass="icon-chevron-down" [options]="options11" [selectedOption]="selectedOptions11" outerLabel="Label"
    dropdownLabelId="dropdownLabelId12" [hasSingleButton]="true" [buttonData]="buttonData1">
    <ng-container ngProjectAs="[message]">
      <div class="c-dropdown__helper-text">
        This is helper text: {{ (selectedOptions11 && selectedOptions11.label)? selectedOptions11.label : label1 }}
      </div>
    </ng-container>
  </maced-dropdown>

   <h2>Use Case 11: Dropdown with option status </h2>
  <maced-dropdown dropdownId="dropdownId13" name="dropdownId13" ariaLabel="Dropdown list navigate with tab" label="label" dropdownText="Dropdown"
  [showChip]= "true" cheveronClass="icon-chevron-down" [options]="options12" [selectedOption]="selectedOptions12" outerLabel="Label" 
    dropdownLabelId="dropdownLabelId13">
    <ng-container ngProjectAs="[message]">
      <div class="c-dropdown__helper-text">
        This is helper text: {{ (selectedOptions12 && selectedOptions12.label)? selectedOptions12.label : label1 }}
      </div>
    </ng-container>
  </maced-dropdown>

  <h2>Use Case 12: Dropdown with logo </h2>
  <maced-dropdown dropdownId="dropdownId14" name="dropdownId14" ariaLabel="Dropdown list navigate with tab" [hasIcon]="true" dropdownText="Dropdown"
    [options]="options13" [selectedOption]="selectedOptions13" outerLabel="Label" iconUrl="../../assets/images/logo-mee-black-mac.svg"
    dropdownLabelId="dropdownLabelId13" [hasSingleButton]="true" [buttonData]="buttonData2" [dropdownWithLogo]="true" ariaLabel="Institute logo" [hideNavigationLabel]="true">
    <ng-container ngProjectAs="[dropdownOptionsHeader]">
       <h2 class="c-dropdown__title">Current profile</h2>
    </ng-container>
    <ng-container ngProjectAs="[applyButton]">
       <maced-button [buttonId]="'buttonList.id'" color="link" size="medium"
            shape="square" buttonType="button" [label]="'Switch profile'" [ariaLabel]="'Switch profile'">
          </maced-button>
    </ng-container>
    <ng-container ngProjectAs="[message]">
      <div class="c-dropdown__helper-text">
        This is helper text: {{ (selectedOptions12 && selectedOptions12.label)? selectedOptions12.label : label1 }}
      </div>
    </ng-container>
  </maced-dropdown>
</div>